import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { LocaleContext } from './layout';
import locales from '../../config/i18n';

const LocalizedLink = ({ to, children, ...props }) => {
  const { locale: ctxLocale } = useContext(LocaleContext) || {};
  const locale = ctxLocale || 'en-gb';
  if (!to) return null;

  const isIndex = to === '/' || to === 'homepage';

  const prefix = locales[locale]?.path || locale;
  const path = `/${prefix}${isIndex ? '' : `/${to}`}`;

  return (
    <Link to={path} lang={locale} hrefLang={locale} rel="alternate" {...props}>
      {children}
    </Link>
  );
};

LocalizedLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default LocalizedLink;
